import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8def0ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f8def0ea&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8def0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8def0ea')) {
      api.createRecord('f8def0ea', component.options)
    } else {
      api.reload('f8def0ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f8def0ea&scoped=true", function () {
      api.rerender('f8def0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/index.vue"
export default component.exports